import { ToggleGroup } from "radix-ui";

export function Segmented<T extends string>({
  value,
  onChange,
  options,
  label,
}: {
  value: T;
  onChange: (value: T) => void;
  options: { value: T; label: React.ReactNode; count?: number }[];
  label: string;
}) {
  return (
    <ToggleGroup.Root
      type="single"
      aria-label={label}
      value={value}
      onValueChange={(v) => v && onChange(v as T)}
      className="inline-flex flex-wrap rounded-[var(--radius-control)] border border-line bg-course p-0.5"
    >
      {options.map((option) => (
        <ToggleGroup.Item
          key={option.value}
          value={option.value}
          className="inline-flex h-7 items-center gap-1.5 rounded-[3px] px-3 text-sm text-muted transition-colors hover:text-text data-[state=on]:bg-surface data-[state=on]:text-text data-[state=on]:shadow-[0_0_0_1px_var(--c-line)]"
        >
          {option.label}
          {option.count !== undefined && option.count > 0 && (
            <span className="num text-xs text-muted">{option.count}</span>
          )}
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
}
